import React, { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { GalleryItemModel } from './Gallery.model';
import { Swiper as SwiperType } from 'swiper';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';

type GallerySliderProps = {
    items?: GalleryItemModel[]
    hideNavigation?: boolean
}

const GallerySlider = ({ items, hideNavigation }: GallerySliderProps) => {
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);
    const swiperRef = useRef<SwiperType>();
    const [isBeginning, setIsBeginning] = useState(false)
    const [isEnd, setIsEnd] = useState(false)

    return (
        <div className='gallery'>
            <Swiper
                spaceBetween={12}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Thumbs, Navigation]}
                className="gallery-slider-primary"
                onBeforeInit={(swiper: SwiperType) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper: SwiperType) => {
                    setIsBeginning(swiper.isBeginning)
                    setIsEnd(swiper.isEnd)
                }}
            >
                {
                    items?.map(_ => (
                        <SwiperSlide key={_.id} >
                            <button onClick={() => window.open(_.image, '_blank')}>
                                <img
                                    src={_.image}
                                    className='h-full object-contain'
                                    alt={_.title}
                                />
                            </button>
                        </SwiperSlide>
                    ))
                }

            </Swiper>
            <div className='relative w-[300px] mx-auto'>
                <Swiper
                    onSwiper={(swiper: SwiperType) => setThumbsSwiper(swiper)}
                    spaceBetween={12}
                    slidesPerView={3}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Thumbs, Navigation]}
                    className='gallery-slider-secondary'
                >
                    {
                        items?.map(_ => (
                            <SwiperSlide key={_.id}>
                                <img className='' src={_.image} alt={_.title} />
                            </SwiperSlide>
                        ))
                    }
                </Swiper>

                <button
                    disabled={isBeginning}
                    onClick={() => swiperRef.current?.slidePrev()}
                    className={twMerge("absolute top-1/2 -translate-y-1/2 -left-9", isBeginning ? "text-neutral-300" : "text-neutral-70")}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 4L7 12L15 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <button
                    disabled={isEnd}
                    onClick={() => swiperRef.current?.slideNext()}
                    className={twMerge("absolute top-1/2 -translate-y-1/2 -right-9", isEnd ? "text-neutral-300" : "text-neutral-70")}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 20L17 12L9 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>


            </div>
        </div>
    )
}

export default GallerySlider